var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTabDialpad = function SvgTabDialpad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.6 16.5",
    style: {
      enableBackground: "new 0 0 16.6 16.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#ACC0D2",
    cx: 2.3,
    cy: 2.3,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ACC0D2",
    cx: 2.3,
    cy: 8.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ACC0D2",
    cx: 14.3,
    cy: 2.3,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ACC0D2",
    cx: 2.3,
    cy: 14.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ACC0D2",
    cx: 8.3,
    cy: 14.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ACC0D2",
    cx: 8.3,
    cy: 8.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ACC0D2",
    cx: 14.3,
    cy: 14.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ACC0D2",
    cx: 14.3,
    cy: 8.3,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ACC0D2",
    cx: 8.3,
    cy: 2.3,
    r: 2.3
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTabDialpad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tab_dialpad.f64cb990.svg";
export { ForwardRef as ReactComponent };